// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { BarcodePrintStatus } from './barcode-print-status';
import { ItemBin } from './item-bin';
import { ItemDetail } from './item-detail';
import { ItemDetailStatus } from './item-detail-status';
import { JoDetail } from './jo-detail';
import { PoDetail } from './po-detail';
import { BarcodePrintStatusEnum } from './enums';
import { ItemDetailStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ItemDetailLog extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Int32 FK account */
  accountId?: number;
  /** Enum FK barcodePrintStatus */
  barcodePrintStatusId!: BarcodePrintStatusEnum;
  /** DateTimeOffset */
  crtnTs!: Date;
  /** String(4) */
  crtnUserInit!: string;
  /** Int32 FK itemBin */
  itemBinId!: number;
  /** String(12) FK itemDetail */
  itemDetailId!: string;
  /** Enum FK itemDetailStatus */
  itemDetailStatusId!: ItemDetailStatusEnum;
  /** Int32 FK joDetail */
  joDetailId?: number;
  /** DateTimeOffset */
  lastScanTs?: Date;
  /** Int32 FK poDetail */
  poDetailId?: number;
  /** FK accountId */
  account!: Account;
  /** FK barcodePrintStatusId */
  barcodePrintStatus!: BarcodePrintStatus;
  /** FK itemBinId */
  itemBin!: ItemBin;
  /** FK itemDetailId */
  itemDetail!: ItemDetail;
  /** FK itemDetailStatusId */
  itemDetailStatus!: ItemDetailStatus;
  /** FK joDetailId */
  joDetail!: JoDetail;
  /** FK poDetailId */
  poDetail!: PoDetail;
}

